import React, {useState, useEffect} from 'react';
import postApiWithToken from '../../../DataServices/postApiWithToken';
import {b2cPolicies} from '../../../authConfig';
import LoadingIndicator from '../../../Layout/LoadingIndicator';
import { Link, useHistory } from 'react-router-dom';

import TagManager from 'react-gtm-module';
// GTM params for my profile page.
const tagManagerArgs = {
    dataLayer: {
        page: 'my-profile',
        event:'spa-pageview'
    }
}

// Main page for my profile. Does not make inital call to the api, instead it receives 
// current customer information as params.
const MyProfile = (props) => {
  const [customerChanges, setCustomerChanges] = useState({ ...props.customer});
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const history = useHistory();
  props.setPage('my-profile');

  useEffect(() =>{
    
    TagManager.dataLayer(tagManagerArgs)
  }, [])

  // Saving customer information.
  useEffect(() => {
    if (loading) {
      (async() => {
        var r = await postApiWithToken(
          props.authProps.account, 
          props.authProps.instance, 
          props.authProps.inProgress, 
          '/customer/updateCustomer/', 
          customerChanges);
          if (r.status === 204) {
            props.setCustomer(customerChanges);
            props.setPage('home')
            history.push("/")
          } else {
            setError('Sorry, your request cannot be completed. If this persist please contact customer service.')
            setIsDisabled(true);
            setIsLoading(false);
          }
      })()
    }
  }, [loading])

  // Changing customer details. Note that email change is not allowed.
  const handleChange = (e) => {
    setCustomerChanges({...customerChanges, [e.target.name]: e.target.value})
    if (e.target.name ==='email') {
    }
    if (isDisabled) setIsDisabled(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
  }

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="my-details">
      <h2>My Profile</h2>
      {error ? <div className="error">{error}</div>:""}
      <form onSubmit={handleSubmit}>
        <div className='profile-form'>
          <label htmlFor="email" className="required">Email</label>
          <input 
            type="email" 
            name="email" 
            id="name" 
            value={props.customer.email} 
            required aria-required="true"
            placeholder="Email address"
            disabled > 
          </input>
          <label htmlFor="firstName" className="required">First Name</label>
          <input 
            type="text" 
            name="firstName" 
            id="firstName" 
            value={customerChanges.firstName} 
            onChange={handleChange} 
            required aria-required="true" 
            placeholder="First Name"> 
          </input>
          <label htmlFor="lastName" className="required">Last Name</label>
          <input 
            type="text" 
            name="lastName" 
            id="lastName" 
            value={customerChanges.lastName} 
            onChange={handleChange} 
            required aria-required="true"
            placeholder="Last Name">
          </input>
          <label htmlFor="phoneNumber" className="required">Phone Number</label>
          <input 
            id="phoneNumber" 
            type="tel" 
            name="phoneNumber"
            value={customerChanges.phoneNumber} 
            onChange={handleChange} 
            required aria-required="true"
            pattern="^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$" placeholder="(555) 555-5555">
          </input>
          {(props.customer.addressLine1 
            && props.customer.city 
            && props.customer.province 
            && props.customer.country) 
            ? <div>
            <label htmlFor="addressLine1" className="required">Mailing Address Line 1</label>
            <input 
              type="text" 
              name="addressLine1" 
              id="addressLine1" 
              value={customerChanges.addressLine1} 
              onChange={handleChange}
              required aria-required="true" 
              placeholder="Mailing Address Line 1">
            </input>
            <label htmlFor="addressLine2">Mailing Address Line 2</label>
            <input 
              type="text" 
              name="addressLine2" 
              id="addressLine2" 
              value={customerChanges.addressLine2} 
              onChange={handleChange} 
              placeholder="Mailing Address Line 2">
            </input>
            <label htmlFor="city" className="required">City</label>
            <input 
              type="text" 
              name="city" 
              id="city" 
              value={customerChanges.city} 
              onChange={handleChange}
              required aria-required="true" 
              placeholder="City">
            </input>
            <label htmlFor="province" className="required">Province</label>
            <input 
              type="text" 
              name="province" 
              id="province" 
              value={customerChanges.province} 
              onChange={handleChange}
              required aria-required="true"  
              placeholder="Province">
            </input>
            <label htmlFor="country" className="required">Country</label>
            <input 
              type="text" 
              name="country" 
              id="country" 
              value={customerChanges.country} 
              onChange={handleChange}
              required aria-required="true" 
              placeholder="Country">
            </input> 
          </div> : "" }
          <label htmlFor="postalCode" className="required">Postal Code</label>
          <input 
            type="text" 
            name="postalCode" 
            id="postalCode" 
            value={customerChanges.postalCode} 
            onChange={handleChange} 
            required aria-required="true"
            pattern="^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$" placeholder="A1A 1A1">
          </input>
        </div>

        <div className="buttons">
          <button 
            type="button" 
            className="cancel btn secondary" 
            onClick={()=>props.authProps.instance.loginRedirect(b2cPolicies.authorities.editProfile)} 
          >Change Password</button>
          <button 
            type="submit" 
            className="save btn primary" 
            disabled={isDisabled} 
          >Save</button>
          <Link
            type="button" 
            className="cancel btn secondary" 
            onClick={()=>props.setPage('home')} 
            to={'/'}
          >Cancel</Link>
        </div>

      </form>
    </div>
  );
}

export default MyProfile;